import { useEffect, useState } from "react";
import { Spin, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";

const { Paragraph, Title } = Typography;
const ExploreMore = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const res = await axiosInstance.get(
        //   `/explore-sections?populate[product_groups][populate][product_details][fields]=title,slug`,
        // );

        const res = await axiosInstance.get(
          `/explore-sections?populate[product_groups][populate][product_details][fields]=title,slug&populate[product_groups][populate][sub_products][fields]=title,slug`,
        );

        setSections(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <Spin size="large" />
      </div>
    );
  }

  if (!sections) return null;

  return (
    <div className="">
      <div className="container">
        {sections.map((section) => (
          <div key={section.id} className="mb-10">
            <Title
              className="!font-medium !text-danger !text-2xl !mb-1 text-center"
              level={2}
            >
              <span className="text-primary">Explore more on </span>
              {section.title}
            </Title>

            {/* Groups */}
            {section.product_groups?.map((group) => {
              const isProductGroup = group.product_details?.length > 0;
              const items = isProductGroup
                ? group.product_details
                : group.sub_products;

              if (!items?.length) return null;

              return (
                <div key={group.id} className="mb-6">
                  {/* Group Title */}
                  <h4 className="text-lg font-semibold mb-3">
                    {group.title || group.name}
                  </h4>

                  {/* Items */}
                  <div className="flex flex-wrap gap-2">
                    {items.slice(0, 10).map((item, index) => (
                      <span
                        key={item.id}
                        onClick={() =>
                          navigate(
                            isProductGroup
                              ? `/product/${item.slug}`
                              : `/sub-product/${item.slug}`,
                          )
                        }
                        className="cursor-pointer flex items-stretch border border-danger rounded-md text-sm overflow-hidden hover:bg-yellow-50"
                      >
                        <span className="flex items-center justify-center bg-danger text-white px-2 text-xs border-r">
                          {index + 1}
                        </span>

                        <span className="px-3 py-1.5 text-xs text-gray-700 font-medium">
                          {item.title}
                        </span>
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExploreMore;
